import React from 'react'
import { Trans, t } from '@lingui/macro'

import IconEnvelope from '../../../components/common/icon/IconEnvelope'
import Tooltip from '../../../components/common/tooltip/Tooltip'
import BorderedBox, {
  BorderedBoxStats
} from '../../../components/common/bordered-box/BorderedBox'
import {
  CampaignActionControls,
  CampaignActionEmailSender
} from './commonComponents'
import { CampaignEmailActionModelAsEditor } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import IconPeople from 'front-end/src/components/common/icon/IconPeople'

import './CampaignAction.less'

const CampaignEmailAction = ({
  email,
  onCopyClick,
  onEditClick,
  onDeleteClick
}: {
  email: CampaignEmailActionModelAsEditor
  onEditClick: (e: React.MouseEvent<HTMLSpanElement>) => void
  onDeleteClick: (e: React.MouseEvent<HTMLSpanElement>) => void
  onCopyClick: (e: React.MouseEvent<HTMLSpanElement>) => void
}) => {
  const hasData = !!(email.sentCount || email.uniqueClickCount)

  return (
    <BorderedBox className="CampaignAction">
      <div className="CampaignAction__icon">
        {email.is_for_manager ? <IconPeople /> : <IconEnvelope />}
      </div>
      <div className="CampaignAction__desc">
        <span>
          <b>
            {email.is_for_manager ? (
              <Trans>Notify manager</Trans>
            ) : (
              <Trans>Send email</Trans>
            )}
            :
          </b>{' '}
          <i>{email.subject}</i>
        </span>
        <CampaignActionEmailSender
          senderName={email.emailIdentity?.name ?? null}
        />
      </div>

      <CampaignActionControls
        onEditClick={onEditClick}
        onDeleteClick={onDeleteClick}
        onCopyClick={onCopyClick}
      />

      <BorderedBoxStats
        stats={[
          {
            className: 'sent',
            caption: t`Sent`,
            value: email.sentCount || (hasData && '0') || '-' // either display sentCount or 0 or "-" if sentCount or clickCount are 0
          },
          {
            className: 'opened',
            caption: (
              <Tooltip
                text={t`Some email clients block tracking so this number may be lower than expected`}
              >
                <Trans>Opened</Trans>*
              </Tooltip>
            ),
            value: email.viewCount || '-' // either display viewCount or "-"
          },
          {
            className: 'clicked',
            caption: t`Clicks`,
            value: email.uniqueClickCount || (hasData && '0') || '-' // either display clickCount or 0 or "-" if viewCount or clickCount are 0
          },
          {
            className: 'effectiveness',
            caption: t`Effectiveness`,
            value:
              (email.effectiveness && `${email.effectiveness}%`) ||
              (hasData && '0%') ||
              '-'
          }
        ]}
      />
    </BorderedBox>
  )
}

export default CampaignEmailAction
